module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iuEGk"))).then(() => module.bundle.root('dsisd'));